import logo from "./logo.svg";
import "./App.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import RegisterSuperAdmin from "./components/RegisterSuperAdmin";
import Login from "./components/Login";
import RegisterStudent from "./components/RegisterStudent";
import Events from "./components/Events";
import UniversityInfo from "./components/UniversityInfo";
import SelectRegister from "./components/SelectRegister";
import RSO from "./components/RSO";
import CreateEvent from "./components/CreateEvent";
import MyRSOs from "./components/MyRSOs";
import ApproveRSOs from "./components/ApproveRSOs";
import ApproveEvents from "./components/ApproveEvents";
import MyUniversity from "./components/MyUniversity";

function App() {
    return (
        <div className="App">
            <Router>
                <Routes>
                    <Route exact path="/" element={<Login />} />
                    <Route
                        exact
                        path="/RegisterStudent"
                        element={<RegisterStudent />}
                    />
                    <Route
                        exact
                        path="/RegisterSuperAdmin"
                        element={<RegisterSuperAdmin />}
                    />
                    <Route
                        exact
                        path="/CreateEvent"
                        element={<CreateEvent />}
                    />
                    <Route exact path="/Events" element={<Events />} />
                    <Route
                        exact
                        path="/SelectRegister"
                        element={<SelectRegister />}
                    />
                    <Route
                        exact
                        path="/UniversityInfo"
                        element={<UniversityInfo />}
                    />
                    <Route exact path="/RSO" element={<RSO />} />
                    <Route exact path="/MyRSOs" element={<MyRSOs />} />
                    <Route exact path="/ApproveRSOs" element={<ApproveRSOs />} />
                    <Route exact path="/ApproveEvents" element={<ApproveEvents />} />
                    <Route exact path="/MyUniversity" element={<MyUniversity />} />
                </Routes>
            </Router>
        </div>
    );
}

export default App;
